module.exports = __webpack_public_path__ + "img/hero-image-personalise@2x.8fcf9aa9.jpg";